import { CheckNullExpectType } from './../../../share/enums-master';
import { SMILE9_API_ENDPOINT } from './../../../../environments/environment';
import { AuthenticateService } from './../../../share/authenticate/authenticate.service';
import { UtilService } from './../../../share/util/util.service';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IImportEmpCsv } from './import-emp-csv-if';

@Injectable()
export class ImportEmpCsvService {
  controlerName = 'api/Smile9ImportEmpCsv';
  subHttpClients = new Subscription();

  constructor(
    public http: HttpClient,
    public utilServ: UtilService,
    public authServ: AuthenticateService,
  ) { }

  public getInit(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subHttpClients.add(
        this.http.get(SMILE9_API_ENDPOINT + `${this.controlerName}`).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  public getEmpCsv(data: IImportEmpCsv.GetEmpCsvModel): Promise<any> {
    return new Promise((resolve, reject) => {
      const params = new HttpParams({ fromObject: {
        co_code: this.utilServ.uType.checkNull(data.co_code, CheckNullExpectType.number, ''),
        dept_code: this.utilServ.uType.checkNull(data.dept_code, CheckNullExpectType.number, ''),
      }});

      this.subHttpClients.add(
        this.http.get(SMILE9_API_ENDPOINT + `${this.controlerName}/EmpCsv`, {params: params}).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  public getCurrentReadyCount(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subHttpClients.add(
        this.http.get(SMILE9_API_ENDPOINT + `${this.controlerName}/CurrentReadyCount`).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  public getLatestEmpAtOnce(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subHttpClients.add(
        this.http.get(SMILE9_API_ENDPOINT + `${this.controlerName}/LatestEmpAtOnce`).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  public getCurrentEmpAtOnceList(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subHttpClients.add(
        this.http.get(SMILE9_API_ENDPOINT + `${this.controlerName}/CurrentEmpAtOnceList`).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  public getImportedHistoryHeader(data: IImportEmpCsv.GetImportedHistoryHeaderModel): Promise<any> {
    return new Promise((resolve, reject) => {
      const params = new HttpParams({ fromObject: {
        dateFrom: this.utilServ.uType.checkNull(data.dateFrom, CheckNullExpectType.string),
        dateTo: this.utilServ.uType.checkNull(data.dateTo, CheckNullExpectType.string),
      }});

      this.subHttpClients.add(
        this.http.get(SMILE9_API_ENDPOINT + `${this.controlerName}/ImportedHistoryHeader`, {params: params}).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  public getImportedHistoryBody(data: IImportEmpCsv.GetImportedHistoryBodyModel): Promise<any> {
    return new Promise((resolve, reject) => {
      const params = new HttpParams({ fromObject: {
        id: this.utilServ.uType.checkNull(data.id, CheckNullExpectType.number),
      }});

      this.subHttpClients.add(
        this.http.get(SMILE9_API_ENDPOINT + `${this.controlerName}/ImportedHistoryBody`, {params: params}).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  public putUpdateCompList(data: IImportEmpCsv.UpdateCompListModel): Promise<any> {
    return new Promise((resolve, reject) => {
      const httpBody: IImportEmpCsv.UpdateCompListModel = {
        newCompList: data.newCompList,
      };
      Object.assign(httpBody, this.utilServ.uTrans.returnBasicColumns());

      this.subHttpClients.add(
        this.http.request('put', SMILE9_API_ENDPOINT + `${this.controlerName}/UpdateCompList`, { body: httpBody }).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  public putCheckLocalCreateCsv(data: IImportEmpCsv.CheckLocalCsvModel): Promise<any> {
    return new Promise((resolve, reject) => {
      const httpBody: IImportEmpCsv.CheckLocalCsvModel = {
        localCsvString: this.utilServ.uType.checkNull(data.localCsvString, CheckNullExpectType.string),
        compList: data.compList,
      };
      Object.assign(httpBody, this.utilServ.uTrans.returnBasicColumns());

      this.subHttpClients.add(
        this.http.request('put', SMILE9_API_ENDPOINT + `${this.controlerName}/CheckLocalCreateCsv`, { body: httpBody }).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  public putCheckLocalEditCsv(data: IImportEmpCsv.CheckLocalCsvModel): Promise<any> {
    return new Promise((resolve, reject) => {
      const httpBody: IImportEmpCsv.CheckLocalCsvModel = {
        localCsvString: this.utilServ.uType.checkNull(data.localCsvString, CheckNullExpectType.string),
        compList: data.compList,
      };
      Object.assign(httpBody, this.utilServ.uTrans.returnBasicColumns());

      this.subHttpClients.add(
        this.http.request('put', SMILE9_API_ENDPOINT + `${this.controlerName}/CheckLocalEditCsv`, { body: httpBody }).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  public putCheckLocalDeleteCsv(data: IImportEmpCsv.CheckLocalCsvModel): Promise<any> {
    return new Promise((resolve, reject) => {
      const httpBody: IImportEmpCsv.CheckLocalCsvModel = {
        localCsvString: this.utilServ.uType.checkNull(data.localCsvString, CheckNullExpectType.string),
        compList: data.compList,
      };
      Object.assign(httpBody, this.utilServ.uTrans.returnBasicColumns());

      this.subHttpClients.add(
        this.http.request('put', SMILE9_API_ENDPOINT + `${this.controlerName}/CheckLocalDeleteCsv`, { body: httpBody }).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  public putCheckLocalDeleteEmpTaskCsv(data: IImportEmpCsv.CheckLocalCsvModel): Promise<any> {
    return new Promise((resolve, reject) => {
      const httpBody: IImportEmpCsv.CheckLocalCsvModel = {
        localCsvString: this.utilServ.uType.checkNull(data.localCsvString, CheckNullExpectType.string),
        compList: data.compList,
      };
      Object.assign(httpBody, this.utilServ.uTrans.returnBasicColumns());

      this.subHttpClients.add(
        this.http.request('put', SMILE9_API_ENDPOINT + `${this.controlerName}/CheckLocalDeleteEmpTaskCsv`, { body: httpBody }).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  public postCreateEmployeeAtOnce(data: IImportEmpCsv.CreateEmployeeAtOnceModel): Promise<any> {
    return new Promise((resolve, reject) => {
      const httpBody: IImportEmpCsv.CreateEmployeeAtOnceModel = {
        createRecords: this.replaceBlankToNull(data.createRecords),
      };
      Object.assign(httpBody, this.utilServ.uTrans.returnBasicColumns());

      this.subHttpClients.add(
        this.http.request('post', SMILE9_API_ENDPOINT + `${this.controlerName}/CreateEmployeeAtOnce`, { body: httpBody }).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  public putEditEmployeeAtOnce(data: IImportEmpCsv.EditEmployeeAtOnceModel): Promise<any> {
    return new Promise((resolve, reject) => {
      const httpBody: IImportEmpCsv.EditEmployeeAtOnceModel = {
        editRecords: this.replaceBlankToNull(data.editRecords),
      };
      Object.assign(httpBody, this.utilServ.uTrans.returnBasicColumns());

      this.subHttpClients.add(
        this.http.request('put', SMILE9_API_ENDPOINT + `${this.controlerName}/EditEmployeeAtOnce`, { body: httpBody }).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  public deleteEmployeeAtOnce(data: IImportEmpCsv.DeleteEmployeeAtOnceModel): Promise<any> {
    return new Promise((resolve, reject) => {
      const httpBody: IImportEmpCsv.DeleteEmployeeAtOnceModel = {
        deleteRecords: this.replaceBlankToNull(data.deleteRecords),
      };
      Object.assign(httpBody, this.utilServ.uTrans.returnBasicColumns());

      this.subHttpClients.add(
        this.http.request('delete', SMILE9_API_ENDPOINT + `${this.controlerName}/DeleteEmployeeAtOnce`, { body: httpBody }).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  public deleteEmpTaskAtOnce(data: IImportEmpCsv.DeleteEmpTaskAtOnceModel): Promise<any> {
    return new Promise((resolve, reject) => {
      const httpBody: IImportEmpCsv.DeleteEmpTaskAtOnceModel = {
        deleteRecords: this.replaceBlankToNull(data.deleteRecords),
      };
      Object.assign(httpBody, this.utilServ.uTrans.returnBasicColumns());

      this.subHttpClients.add(
        this.http.request('delete', SMILE9_API_ENDPOINT + `${this.controlerName}/DeleteEmpTaskAtOnce`, { body: httpBody }).subscribe(
          res => resolve(res),
          error => reject(error)
        )
      );
    });
  }

  /** 更新レコードの空白文字を全てnullに置き換え */
  private replaceBlankToNull(records: any[]): any[] {
    records = records.map(record => {
      Object.keys(record).forEach(key => {
        if (record[key] === '') {
          record[key] = null;
        }
      });
      return record;
    });
    return records;
  }
}
